import { Action, type ActionProps } from '@cvent/analytics/Action';
import { MapView } from '@/constants/mapConstants';

/**
 * Properties that will be tracked as part of this action.
 */
export interface AdClickedProps extends ActionProps {
  /**
   * Fact type
   */
  type: 'csn_ad_click';
  /**
   * Type of Ad
   */
  ad_type: string;
  /**
   * Ads
   */
  ads: string;
  /**
   * Click target
   */
  click_target: string;
  /**
   * Product
   */
  product: string;
  /**
   * Page
   */
  page: string;
  /**
   * Page URL
   */
  page_url: string;
  /**
   * Current map view
   */
  map_view: MapView;
  /**
   * Search term
   */
  search_term: string;
  /**
   * RFP Id (if present)
   */
  rfp_id: string;
  /**
   * Click source
   */
  source: string;
  /**
   * Whether the venue is a fast responder or not
   */
  fast_responder: string;
}

/**
 * @description This action tracks clicks on ad
 * @trigger This action is triggered when a user clicks on a venue that is an ad
 */
export class AdClicked extends Action<AdClickedProps> {
  id = 'ad.clicked';
}

export default AdClicked;
